import { EventEmitter } from "@angular/core";
import { SessionSummary } from '../../../shared/model/session-summary.model';
import { SessionService } from '../session.service';
import moment from "moment/moment";
import * as i0 from "@angular/core";
import * as i1 from "../session.service";
import * as i2 from "@angular/common";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i5 from "@angular/forms";
import * as i6 from "@angular/material/checkbox";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "@ngx-translate/core";
function SessionSummaryComponent_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 13);
    i0.ɵɵlistener("click", function SessionSummaryComponent_fa_icon_4_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.hideSessionSummary(true); });
    i0.ɵɵelementEnd();
} }
function SessionSummaryComponent_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 14);
    i0.ɵɵlistener("click", function SessionSummaryComponent_fa_icon_5_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.hideSessionSummary(false); });
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "rating-star-hover": a0 }; };
function SessionSummaryComponent_div_11_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "fa-icon", 41);
    i0.ɵɵlistener("click", function SessionSummaryComponent_div_11_div_7_Template_fa_icon_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const i_r14 = restoredCtx.index; const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.highlightStar(i_r14); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r14 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, i_r14 <= ctx_r9.maxHighLightIndex));
} }
function SessionSummaryComponent_div_11_div_29_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const workedOnItem_r18 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", workedOnItem_r18);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(workedOnItem_r18);
} }
function SessionSummaryComponent_div_11_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵlistener("click", function SessionSummaryComponent_div_11_div_29_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.showDropDown(); });
    i0.ɵɵelementStart(1, "select", 43);
    i0.ɵɵlistener("ngModelChange", function SessionSummaryComponent_div_11_div_29_Template_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.workedOn = $event; });
    i0.ɵɵtemplate(2, SessionSummaryComponent_div_11_div_29_option_2_Template, 2, 2, "option", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r11.workedOn);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.workedOnOptions);
} }
function SessionSummaryComponent_div_11_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵlistener("click", function SessionSummaryComponent_div_11_div_30_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.isEmpty(); });
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "textarea", 46);
    i0.ɵɵlistener("ngModelChange", function SessionSummaryComponent_div_11_div_30_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.workedOn = $event; });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 3, "sessionChat.placeholder.workedOn"));
    i0.ɵɵproperty("ngModel", ctx_r12.workedOn);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r12.getCommentLength(ctx_r12.improvable), " / 500");
} }
function SessionSummaryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelement(3, "h4", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelement(5, "input", 18);
    i0.ɵɵelementStart(6, "div", 19);
    i0.ɵɵtemplate(7, SessionSummaryComponent_div_11_div_7_Template, 2, 3, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "form", 21, 22);
    i0.ɵɵlistener("ngSubmit", function SessionSummaryComponent_div_11_Template_form_ngSubmit_8_listener() { i0.ɵɵrestoreView(_r26); const _r10 = i0.ɵɵreference(9); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.onSubmitSessionSummary(_r10); });
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵelement(12, "h4", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div");
    i0.ɵɵelementStart(14, "textarea", 24);
    i0.ɵɵlistener("ngModelChange", function SessionSummaryComponent_div_11_Template_textarea_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.wentWell = $event; });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 25);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div");
    i0.ɵɵelementStart(19, "div");
    i0.ɵɵelement(20, "h4", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div");
    i0.ɵɵelementStart(22, "textarea", 27);
    i0.ɵɵlistener("ngModelChange", function SessionSummaryComponent_div_11_Template_textarea_ngModelChange_22_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.improvable = $event; });
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 25);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 28);
    i0.ɵɵelementStart(27, "div");
    i0.ɵɵelement(28, "h4", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, SessionSummaryComponent_div_11_div_29_Template, 3, 2, "div", 30);
    i0.ɵɵtemplate(30, SessionSummaryComponent_div_11_div_30_Template, 6, 5, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 31);
    i0.ɵɵelementStart(32, "mat-checkbox", 32);
    i0.ɵɵlistener("ngModelChange", function SessionSummaryComponent_div_11_Template_mat_checkbox_ngModelChange_32_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.isLastSession = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 33);
    i0.ɵɵelement(34, "span", 34);
    i0.ɵɵelement(35, "fa-icon", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 31);
    i0.ɵɵelementStart(37, "mat-checkbox", 36);
    i0.ɵɵlistener("ngModelChange", function SessionSummaryComponent_div_11_Template_mat_checkbox_ngModelChange_37_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.isReferred = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 33);
    i0.ɵɵelement(39, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 38);
    i0.ɵɵelement(41, "button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(13);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r2.stars);
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(15, 13, "sessionChat.placeholder.wentWell"));
    i0.ɵɵproperty("ngModel", ctx_r2.wentWell);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r2.getCommentLength(ctx_r2.wentWell), " / 500");
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(23, 15, "sessionChat.placeholder.improvable"));
    i0.ɵɵproperty("ngModel", ctx_r2.improvable);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r2.getCommentLength(ctx_r2.improvable), " / 500");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.isDropdown);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isDropdown);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r2.isLastSession);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbPopover", _r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r2.isReferred);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r2.isProcessing);
} }
function SessionSummaryComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelement(1, "p", 48);
    i0.ɵɵelementEnd();
} }
const _c1 = function (a0) { return { "background-color": a0 }; };
const _c2 = function (a0) { return { "padding": a0 }; };
export class SessionSummaryComponent {
    constructor(sessionService) {
        this.sessionService = sessionService;
        this.closeSessionSummaryOutput = new EventEmitter();
        this.hideSessionSummaryOutput = new EventEmitter();
        this.ratingOutput = new EventEmitter();
        this.hideContent = false;
        this.stars = [1, 2, 3, 4, 5];
        this.sessionSummary = new SessionSummary();
        this.isDropdown = true;
        this.isProcessing = false;
        this.workedOnOptions = [
            'Family challenges(kids/marriage)', 'Financial issues', 'Covid-19 related issues', 'Interpersonal work issues(manager/colleague)',
            'Career challenges/expectations', 'Work-life balance', 'Organizational change stress', 'Bullying/harassment at work',
            'Time management/setting boundaries', 'Stress & anxiety', 'Overwhelmed & low energy', 'Personal expectations(perfectionism)',
            'Physical health/sleep', 'Other issue'
        ];
    }
    ngOnInit() {
        this.getSessionSummarySubscription = this.sessionService.getSessionSummaryBySessionId(this.sessionId).subscribe((res) => {
            console.log(res);
            this.sessionSummary = res.body;
            this.isLastSession = this.sessionSummary.isLastSession;
            this.isReferred = this.sessionSummary.isReferred;
            this.improvable = this.sessionSummary.improvable;
            this.maxHighLightIndex = this.sessionSummary.rating - 1;
            this.wentWell = this.sessionSummary.wentWell;
            this.workedOn = this.sessionSummary.workedOn;
        }, (errorResponse) => {
            console.log(errorResponse);
        });
    }
    hideSessionSummary(e) {
        this.hideContent = e;
        this.hideSessionSummaryOutput.emit(this.hideContent);
    }
    closeSessionSummary(e) {
        this.showSessionSummary = e;
        this.closeSessionSummaryOutput.emit(this.showSessionSummary);
        this.ratingOutput.emit(this.maxHighLightIndex);
    }
    setBackgroundColor() {
        return this.hideContent ? '#E0F2EE' : 'white';
    }
    setPadding() {
        return this.hideContent ? '0 5px 5px 5px' : '0 30px 30px 30px';
    }
    highlightStar(i) {
        this.maxHighLightIndex = i;
    }
    onSubmitSessionSummary(form) {
        this.isProcessing = true;
        this.sessionSummary.rating = this.maxHighLightIndex === 5 ? 5 : this.maxHighLightIndex + 1;
        this.sessionSummary.creationDate = moment();
        this.sessionSummary.wentWell = form.value.wentWell;
        this.sessionSummary.improvable = form.value.improvable;
        this.sessionSummary.workedOn = form.value.workedOn;
        this.sessionSummary.isLastSession = form.value.isLastSession;
        this.sessionSummary.isReferred = form.value.isReferred;
        this.sessionSummary.sessionId = this.sessionId;
        console.log(this.sessionSummary);
        this.saveSessionSummarySubscription = this.sessionService.saveSessionSummary(this.sessionSummary).subscribe(response => {
            console.log(response);
            this.closeSessionSummary(false);
        }, error => {
            console.log(error);
        }, () => {
            this.isProcessing = false;
        });
    }
    getCommentLength(field) {
        return !field ? 0 : field.length;
    }
    showDropDown() {
        setTimeout(() => {
            this.isDropdown = this.workedOn !== 'Other issue';
        }, 100);
    }
    isEmpty() {
        if (this.workedOn === 'Other issue')
            this.workedOn = null;
    }
    ngOnDestroy() {
        if (this.getSessionSummarySubscription)
            this.getSessionSummarySubscription.unsubscribe();
        if (this.saveSessionSummarySubscription)
            this.saveSessionSummarySubscription.unsubscribe();
    }
}
SessionSummaryComponent.ɵfac = function SessionSummaryComponent_Factory(t) { return new (t || SessionSummaryComponent)(i0.ɵɵdirectiveInject(i1.SessionService)); };
SessionSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionSummaryComponent, selectors: [["session-summary"]], inputs: { showSessionSummary: "showSessionSummary", sessionId: "sessionId" }, outputs: { closeSessionSummaryOutput: "closeSessionSummaryOutput", hideSessionSummaryOutput: "hideSessionSummaryOutput", ratingOutput: "ratingOutput" }, decls: 14, vars: 9, consts: [[1, "olha-theme"], ["role", "document", 1, "modal-dialog"], [1, "modal-content", 2, "border", "none!important", 3, "ngStyle"], [1, "d-flex", "justify-content-end", "session-summary-icons"], ["icon", "chevron-circle-up", 3, "click", 4, "ngIf"], ["icon", "chevron-circle-down", 3, "click", 4, "ngIf"], ["icon", "times-circle", 3, "click"], [1, "modal-body", "olha-theme", "modal-body-session-summary", 3, "ngStyle"], [1, "d-flex", "justify-content-center", "align-items-center"], [1, "session-ended"], ["jhiTranslate", "sessionChat.paragraph.sessionEnded"], [4, "ngIf"], ["programCompletedPopover", ""], ["icon", "chevron-circle-up", 3, "click"], ["icon", "chevron-circle-down", 3, "click"], [1, "text-center", "how-session"], ["jhiTranslate", "sessionChat.paragraph.howSession"], [1, "rating-stars"], ["type", "hidden", "readonly", "readonly", "name", "another-rating-stars-value", "value", "0", 1, "rating-value"], [1, "rating-stars-container"], ["class", "rating-star-md", 4, "ngFor", "ngForOf"], [3, "ngSubmit"], ["sessionSummaryForm", "ngForm"], ["jhiTranslate", "sessionChat.paragraph.wentWell"], ["rows", "3", "maxlength", "500", "name", "wentWell", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [1, "text-right"], ["jhiTranslate", "sessionChat.paragraph.improvable"], ["rows", "3", "maxlength", "500", "name", "improvable", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [2, "margin-bottom", "15px"], ["jhiTranslate", "sessionChat.paragraph.workedOn"], [3, "click", 4, "ngIf"], [1, "d-flex", "justify-content-start"], ["name", "isLastSession", 1, "check-box", 3, "ngModel", "ngModelChange"], [1, "program-text"], ["jhiTranslate", "sessionChat.paragraph.programCompleted"], ["icon", "info-circle", 1, "program-completed", 3, "ngbPopover"], ["name", "isReferred", 1, "check-box", 3, "ngModel", "ngModelChange"], ["jhiTranslate", "sessionChat.paragraph.coacheeReferred"], [1, "alert-box-actions", 2, "text-align", "center", "margin-top", "10px!important"], ["type", "submit", "jhiTranslate", "sessionChat.button.submit", 1, "btn", "btn-gradient-primary", "font-weight-bold", "rounded-button", 2, "margin", "5px", "border-radius", "40px", "width", "100px", 3, "disabled"], [1, "rating-star-md"], ["icon", "star", 3, "ngClass", "click"], [3, "click"], ["name", "workedOn", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["rows", "3", "maxlength", "500", "name", "workedOn", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [1, "mt-2"], ["jhiTranslate", "sessionChat.paragraph.programCompletedPopover"]], template: function SessionSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, SessionSummaryComponent_fa_icon_4_Template, 1, 0, "fa-icon", 4);
        i0.ɵɵtemplate(5, SessionSummaryComponent_fa_icon_5_Template, 1, 0, "fa-icon", 5);
        i0.ɵɵelementStart(6, "fa-icon", 6);
        i0.ɵɵlistener("click", function SessionSummaryComponent_Template_fa_icon_click_6_listener() { return ctx.closeSessionSummary(false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵelement(10, "h3", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, SessionSummaryComponent_div_11_Template, 42, 17, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, SessionSummaryComponent_ng_template_12_Template, 2, 0, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c1, ctx.setBackgroundColor()));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hideContent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hideContent);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c2, ctx.setPadding()));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.hideContent);
    } }, directives: [i2.NgStyle, i2.NgIf, i3.FaIconComponent, i4.JhiTranslateDirective, i2.NgForOf, i5.ɵNgNoValidate, i5.NgControlStatusGroup, i5.NgForm, i5.DefaultValueAccessor, i5.MaxLengthValidator, i5.NgControlStatus, i5.NgModel, i6.MatCheckbox, i7.NgbPopover, i2.NgClass, i5.SelectControlValueAccessor, i5.NgSelectOption, i5.ɵNgSelectMultipleOption], pipes: [i8.TranslatePipe], styles: [".session-summary-icons[_ngcontent-%COMP%]{color:#8a9d98;cursor:pointer;margin-right:20px;margin-top:20px}.session-summary-icons[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%]{padding-left:5px}.modal-body[_ngcontent-%COMP%]{padding:0}.modal-body-session-summary[_ngcontent-%COMP%]{border-radius:20px}.session-ended[_ngcontent-%COMP%]{margin-bottom:22px}.how-session[_ngcontent-%COMP%]{margin-bottom:8px}.rating-stars[_ngcontent-%COMP%]{margin-bottom:30px}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38b !important}.check-box[_ngcontent-%COMP%]{margin-right:8px}.program-text[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif;font-style:normal;font-size:14px;line-height:140%;color:#0a4a3a}.program-completed[_ngcontent-%COMP%]{margin-left:5px;cursor:pointer}.alert-box-actions[_ngcontent-%COMP%]{text-align:center;margin-top:10px !important}.rounded-button[_ngcontent-%COMP%]{margin:8px;padding-top:3px !important;padding-bottom:3px !important}textarea[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{border:1px solid #8a9d98 !important}"] });
